import React, { useEffect, useState } from 'react'
import { postCirugiaReservadoPor, postListaChequeoInsert, postSelectCambiarEstadoPaciente } from '../../../services/PaginaRuta'
import { calcularEdad } from '../../../hooks/UseDate'
import ConfimarListaChequeo from './ConfimarListaChequeo'
import ModalFaltoCamposPorDiligenciarListaChequeo from './ModalFaltoCamposPorDiligenciarListaChequeo'
import ModalValidacionSignosVitalesListaChequeo from './ModalValidacionSignosVitalesListaChequeo'

const ListaDeChequeoPreparacionPreoperatoriaPrincipal = ({setmodalOnListaChequeo, user, passChildCambioDeEstado, setmodalOnCambioEstadoIngresoSala, passDataActualizaTablaPacientes}) => {
    const [modalOnFaltoDiligenciarCampos, setmodalOnFaltoDiligenciarCampos]=useState(false)
    const [loading, setloading]=useState(true)
    const [nombreMedico, setnombreMedico]=useState('')
    const [lateralidadV, setlateralidadV]=useState('')
    const [modalOnConfirmarListaChequeo, setmodalOnConfirmarListaChequeo]=useState(false)
    const [modalOnValidacionesSignosVitales, setmodalOnValidacionesSignosVitales]=useState(false)
    const [validacionesSignosVitales, setvalidacionesSignosVitales]=useState({
      frecuenciaCardiaca:'',      
      temperatura:'',
      presionSistolica:'',
      presionDiastolica:'',
      
    })
    const [dataListaChequeo, setdataListaChequeo]=useState({
        "ProCirCod": '',
        "ProEmpCod": '',
        "ProMCDpto": '',
        "nombreCompleto": '',
        "numeroDocumento": '',
        "procedimientoRealizar": '',
        "lateralidad": '',
        "nombreCirujano":'',
        "fechaCirugia":'',
        "fechaNacimiento": '',
        "tipoSangre": '',
        "alergias": '',
        "cualesAlergias": '',
        "hipertensionArterial": '',
        "administraAntihipertensivoPrevio": '',
        "diabetesMellitus": '',
        "antiCoagulado": '',
        "caida": '',
        "upp": '',
        "antibioticoProfilactico": '',
        "administracionProfilaxis": '',
        "fechaHoraAdministracion": '',
        "glucometria": '',
        "seCorrigeCon": '',
        "sintomatologiaRespiratoria": '',
        "sintomatologiaRespiratoriaTextArea": '',
        "ayunoCorrecto": '',
        "ayunoCorrectoTextArea":'',
        "accesoVeneso":'',
        "accesoVenesoTextArea": '',
        "adultoCateter": '',
        "adultoCateterTextArea": '',
        "pediatricoCateter": '',
        "pediatricoCateterTextArea": '',
        "eliminacionVello": '',
        "eliminacionVelloTextArea": '',
        "laboratorioPreQuirurgico": '',
        "laboratorioPreQuirurgicoTextArea": '',
        "electrocardiograma": '',
        "electrocardiogramaTextArea": '',
        "medicamentosAntihipertensivosOPatologias":'',
        "medicamentosAntihipertensivosOPatologiasTextArea": '',
        "medicamentosAnestesiologo": '',
        "medicamentosAnestesiologoTextArea": '',
        "cuentaConReserva": '',
        "cuentaConReservaTextArea": '',
        "consentimientoCirugia": '',
        "consentimientoCirugiaTextArea": '',
        "consentimientoAnestesia": '',
        "consentimientoAnestesiaTextArea": '',
        "materialOsteosintesisOInsumos": '',
        "materialOsteosintesisOInsumosTextArea": '',
        "reservaUCI": '',
        "reservaUCITextArea": '',
        "pacienteUnasMaquillaje": '',
        "pacienteUnasMaquillajeTextArea":'',
        "observaciones":'',
        "frecuenciaCardiaca":'',
        "saturacionOxigeno":'',
        "temperatura":'',
        "viaTemperatura":'',
        "presionSistolica":'',
        "presionDiastolica":'',
        "peso":'',
        "talla":''
    })
    const [validarAlergiasSiEsSi, setvalidarAlergiasSiEsSi]=useState(true)

    const handleCancelarClick=()=>{
      setmodalOnListaChequeo(false)
    }

    useEffect(()=>{
      const buscarMedico = {
        varMMEstado: "A",
        varEspEst: "S",
        varMEEstE: "S",
        varMMCedM: '',
        varMMNomM: '',
        varMMCODM: user.ProPerSe1,
      };
      setloading(false)
      postCirugiaReservadoPor(buscarMedico).then((res)=>{
        setloading(true)        
        if(res.data[0]){
          setnombreMedico(res.data[0].MMNomM)
        }        
      })

      //Lateralidad
      const arrayLateralidad={
        " ": '',
        "D": 'Derecho',
        "I": 'Izquierdo',
        "B": 'Bilateral',
        "N": 'No aplica'
      }
      const variableLateralidad = user.ProLat      
      if(arrayLateralidad[variableLateralidad]){
        setlateralidadV(arrayLateralidad[variableLateralidad])
      }
    },[])

    
    const handleOnSubmitGuardarListaChequeo=(e)=>{
      e.preventDefault()
      //console.log(e.target.administracionProfilaxis.value, 'administracionProfilaxis')
      //console.log(e.target.sintomatologiaRespiratoriaTextArea.value,' sintomatologiaRespiratoria')
      setdataListaChequeo({
        "ProCirCod": user.ProCirCod,
        "ProEmpCod": user.ProEmpCod,
        "ProMCDpto": user.ProMCDpto,
        "nombreCompleto": user.MPNOMC,
        "numeroDocumento": user.MPCedu,
        "procedimientoRealizar": user.CrgDes,
        "lateralidad": lateralidadV,
        "nombreCirujano": nombreMedico,
        "fechaCirugia":user.ProFec? user.ProFec.split(' ')[0]:null,
        "fechaNacimiento": user.MPFchN? user.MPFchN.split(' ')[0]:null,
        "tipoSangre": e.target.tipoSangre.value,
        "alergias": e.target.alergias.value,
        "cualesAlergias": e.target.cualesAlergias.value,
        "hipertensionArterial": e.target.hipertensionArterial.value,
        "administraAntihipertensivoPrevio": e.target.administraAntihipertensivoPrevio.value,
        "diabetesMellitus": e.target.diabetesMellitus.value,
        "antiCoagulado": e.target.antiCoagulado.value,
        "caida": e.target.caida.value,
        "upp": e.target.upp.value,
        "antibioticoProfilactico": e.target.antibioticoProfilactico.value,
        "administracionProfilaxis": e.target.administracionProfilaxis.value,
        "fechaHoraAdministracion": e.target.fechaHoraAdministracion.value,
        "glucometria": e.target.glucometria.value,
        "seCorrigeCon": e.target.seCorrigeCon.value,
        "sintomatologiaRespiratoria": e.target.sintomatologiaRespiratoria.value,
        "sintomatologiaRespiratoriaTextArea": e.target.sintomatologiaRespiratoriaTextArea.value,
        "ayunoCorrecto": e.target.ayunoCorrecto.value,
        "ayunoCorrectoTextArea": e.target.ayunoCorrectoTextArea.value,
        "accesoVeneso": e.target.accesoVeneso.value,
        "accesoVenesoTextArea": e.target.accesoVenesoTextArea.value,
        "adultoCateter": e.target.adultoCateter.value,
        "adultoCateterTextArea": e.target.adultoCateterTextArea.value,
        "pediatricoCateter": e.target.pediatricoCateter.value,
        "pediatricoCateterTextArea": e.target.pediatricoCateterTextArea.value,
        "eliminacionVello": e.target.eliminacionVello.value,
        "eliminacionVelloTextArea": e.target.eliminacionVelloTextArea.value,
        "laboratorioPreQuirurgico": e.target.laboratorioPreQuirurgico.value,
        "laboratorioPreQuirurgicoTextArea": e.target.laboratorioPreQuirurgicoTextArea.value,
        "electrocardiograma": e.target.electrocardiograma.value,
        "electrocardiogramaTextArea": e.target.electrocardiogramaTextArea.value,
        "medicamentosAntihipertensivosOPatologias": e.target.medicamentosAntihipertensivosOPatologias.value,
        "medicamentosAntihipertensivosOPatologiasTextArea": e.target.medicamentosAntihipertensivosOPatologiasTextArea.value,
        "medicamentosAnestesiologo": e.target.medicamentosAnestesiologo.value,
        "medicamentosAnestesiologoTextArea": e.target.medicamentosAnestesiologoTextArea.value,
        "cuentaConReserva": e.target.cuentaConReserva.value,
        "cuentaConReservaTextArea": e.target.cuentaConReservaTextArea.value,
        "consentimientoCirugia": e.target.consentimientoCirugia.value,
        "consentimientoCirugiaTextArea": e.target.consentimientoCirugiaTextArea.value,
        "consentimientoAnestesia": e.target.consentimientoAnestesia.value,
        "consentimientoAnestesiaTextArea": e.target.consentimientoAnestesiaTextArea.value,
        "materialOsteosintesisOInsumos": e.target.materialOsteosintesisOInsumos.value,
        "materialOsteosintesisOInsumosTextArea": e.target.materialOsteosintesisOInsumosTextArea.value,
        "reservaUCI": e.target.reservaUCI.value,
        "reservaUCITextArea": e.target.reservaUCITextArea.value,
        "pacienteUnasMaquillaje": e.target.pacienteUnasMaquillaje.value,
        "pacienteUnasMaquillajeTextArea": e.target.pacienteUnasMaquillajeTextArea.value,
        "observaciones":e.target.observaciones.value,
        "frecuenciaCardiaca": e.target.frecuenciaCardiaca.value,
        "saturacionOxigeno": e.target.saturacionOxigeno.value,
        "temperatura": e.target.temperatura.value,
        "viaTemperatura": e.target.viaTemperatura.value,
        "presionSistolica": e.target.presionSistolica.value,
        "presionDiastolica": e.target.presionDiastolica.value,
        "peso": e.target.peso.value,
        "talla": e.target.talla.value
      })

      let validarAlergias= true
      // Verifica si el valor de 'alergias' es '1', lo que indica que el usuario tiene alergias
      if (e.target.alergias.value === '1') {
        // Si el usuario ha indicado cuáles son las alergias, se establece la validación como falsa
        if(e.target.cualesAlergias.value){
          setvalidarAlergiasSiEsSi(true)
        validarAlergias = true
        }else{
          setvalidarAlergiasSiEsSi(false)
          validarAlergias=  false 
        }            
      }else{
        setvalidarAlergiasSiEsSi(true)
        validarAlergias = true
      }

      if(validarAlergias      
         && e.target.frecuenciaCardiaca.value 
        && e.target.temperatura.value && e.target.presionSistolica.value 
        && e.target.presionDiastolica.value 
         
        &&  e.target.saturacionOxigeno.value
      ){
        const validarSignosVitales = validarSignosVitalesPaciente(e.target.frecuenciaCardiaca.value, e.target.temperatura.value)
        if(validarSignosVitales){
          setmodalOnValidacionesSignosVitales(true)
        }else{
          setmodalOnConfirmarListaChequeo(true)
        }
        
      }else{
        setmodalOnFaltoDiligenciarCampos(true)
      }
     
    }

    const validarSignosVitalesPaciente = (frecuenciaCardiaca, temperatura) => {
      let validacion = false;
    
      // Validación para frecuencia cardiaca
      if (frecuenciaCardiaca < 20) {
        setvalidacionesSignosVitales((prevState) => ({
          ...prevState,
          frecuenciaCardiaca: 'La frecuencia cardiaca debe ser mayor de 20',
        }));
        validacion = true;
      } else {
        setvalidacionesSignosVitales((prevState) => ({
          ...prevState,
          frecuenciaCardiaca: '',  // Limpia el mensaje si la validación pasa
        }));
      }
    
      
      // Validación para temperatura
      if (temperatura < 31 || temperatura > 44) {
        setvalidacionesSignosVitales((prevState) => ({
          ...prevState,
          temperatura: 'La temperatura debe ser entre 31 y 44',
        }));
        validacion = true;
      } else {
        setvalidacionesSignosVitales((prevState) => ({
          ...prevState,
          temperatura: '',  // Limpia el mensaje si la validación pasa
        }));
      }

      

     
    
      return validacion;
    };
    

    
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
       <div className="sm:h-[calc(100%)] max-w-7xl   mx-auto relative w-auto pointer-events-none ">
        <div className=" max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              LISTA DE CHEQUEO PREPARACIÓN PREOPERATORIA DEL PACIENTE 
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative px-2">
            <div className="bg-[#05a29d] mt-3 text-center">
                <label className="form-label inline-block m-1 text-white font-medium text-center text-xl">
                IDENTIFICACIÓN DEL PACIENTE 
                </label>
            </div>
            <form onSubmit={handleOnSubmitGuardarListaChequeo}>
                <div className="flex py-2 text-left">
                    <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Nombre Completo
                    </label>
                    <input       
                        defaultValue={user.MPNOMC}             
                        type="text"
                        disabled={true}
                        name="nombreCompleto"
                        autoComplete="off"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                    />
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Número Documento
                    </label>
                    <input       
                        defaultValue={user.MPCedu}             
                        type="text"
                        disabled={true}
                        name="numeroDocumento"
                        autoComplete="off"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                    />
                    </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Procedimiento a Realizar
                  </label>
                  <input       
                    defaultValue={user.CrgDes}             
                    type="text"
                    disabled={true}
                    name="procedimientoRealizar"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Lateralidad
                  </label>
                  <input       
                    defaultValue={lateralidadV}             
                    type="text"
                    disabled={true}
                    name="lateralidad"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Nombre Cirujano
                  </label>
                  <input       
                    defaultValue={nombreMedico}             
                    type="text"
                    disabled={true}
                    name="nombreCirujano"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Fecha Cirugía 
                  </label>
                  <input       
                    defaultValue={user.ProFec? user.ProFec.split(' ')[0]:null}             
                    type="text"
                    disabled={true}
                    name="fechaCirugia"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Edad
                  </label>
                  <input       
                    defaultValue={calcularEdad(user.MPFchN? user.MPFchN.split(' ')[0]:null)}             
                    type="text"
                    disabled={true}
                    name="edad"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Tipo de Sangre
                  </label>
                  <input       
                    //defaultValue={tipoRIPS}             
                    type="text"
                    //disabled={true}
                    name="tipoSangre"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Alergias
                  </label>
                  <select                    
                    type="text"
                    name="alergias"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="0">NO</option>
                        <option value="1">SI</option>
                        
                  </select>
                  
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Cuales
                  </label>
                  <textarea
                    //onChange={handleOnchangeDescripcion}                
                    type="text"
                    name="cualesAlergias"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                </div>
                <div className="bg-[#05a29d] mt-3 text-center">
                  <label className="form-label inline-block m-1 text-white font-medium text-center text-xl">
                    ANTECENDENTES CLINICOS 
                  </label>                
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Hipertensión arterial
                  </label>
                  <select                    
                    type="text"
                    name="hipertensionArterial"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="0">NO</option>
                        <option value="1">SI</option>
                        
                  </select>
                  
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Se administra antihipertensivo previo a la cirugía
                  </label>
                  <select                    
                    type="text"
                    name="administraAntihipertensivoPrevio"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="0">NO</option>
                        <option value="1">SI</option>
                        
                  </select>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Diabetes mellitus
                  </label>
                  <select                    
                    type="text"
                    name="diabetesMellitus"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="0">NO</option>
                        <option value="1">SI</option>
                        
                  </select>
                  
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Anti Coagulado
                  </label>
                  <select                    
                    type="text"
                    name="antiCoagulado"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="0">NO</option>
                        <option value="1">SI</option>
                        
                  </select>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  R. Caída
                  </label>
                  <select       
                    //defaultValue={tipoRIPS}             
                    type="text"
                    //disabled={true}
                    name="caida"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    <option value="0">NO</option>
                    <option value="1">SI</option>
                  </select>
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  r.upp
                  </label>
                  <select       
                    //defaultValue={tipoRIPS}             
                    type="text"
                    //disabled={true}
                    name="upp"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    <option value="0">NO</option>
                    <option value="1">SI</option>
                  </select>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Nombre de antibiótico profiláctico
                  </label>
                  <input       
                    //defaultValue={tipoRIPS}             
                    type="text"
                    //disabled={true}
                    name="antibioticoProfilactico"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Hora de administración de la profilaxis antibiótica
                  </label>
                  <input       
                    //defaultValue={tipoRIPS}             
                    type="time"
                    //disabled={true}
                    name="administracionProfilaxis"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Fecha y hora de ultima administración
                  </label>
                  <input       
                    //defaultValue={tipoRIPS}             
                    type="datetime-local"
                    //disabled={true}
                    name="fechaHoraAdministracion"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Valor de la glucometria
                  </label>
                  <input       
                    //defaultValue={tipoRIPS}             
                    type="text"
                    //disabled={true}
                    name="glucometria"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Se corrige con
                  </label>
                  <input       
                    //defaultValue={tipoRIPS}             
                    type="text"
                    //disabled={true}
                    name="seCorrigeCon"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                  
                </div>
                <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-300">
                  <thead>
                    <tr className='bg-[#05a29d] text-white'>
                      <th className="px-4 py-2 border-b">N°</th>
                      <th className="px-4 py-2 border-b">ITEM</th>
                      <th className="px-4 py-2 border-b">OPCION</th>            
                      <th className="px-4 py-2 border-b w-64">OBSERVACIÓN</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">1</td>
                        <td className="px-4 py-2 border-b text-left">Paciente presenta sintomatología respiratoria</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='sintomatologiaRespiratoria'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='sintomatologiaRespiratoriaTextArea'
                          />
                        </td>
                      </tr>          
                      <tr  className="hover:bg-gray-100 bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">2</td>
                        <td className="px-4 py-2 border-b text-left">Ayuno correcto</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='ayunoCorrecto'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='ayunoCorrectoTextArea'
                          />
                        </td>
                      </tr>   
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">3</td>
                        <td className="px-4 py-2 border-b text-left">Paciente con acceso venoso</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='accesoVeneso'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='accesoVenesoTextArea'
                          />
                        </td>
                      </tr>    
                      <tr  className="hover:bg-gray-100 bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">4</td>
                        <td className="px-4 py-2 border-b text-left">Paciente Adulto: catéter # 18</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='adultoCateter'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='adultoCateterTextArea'
                          />
                        </td>
                      </tr>   
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">5</td>
                        <td className="px-4 py-2 border-b text-left">Paciente Pediátrico :catéter # 22 o 24</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='pediatricoCateter'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='pediatricoCateterTextArea'
                          />
                        </td>
                      </tr>    
                      <tr  className="hover:bg-gray-100 bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">6</td>
                        <td className="px-4 py-2 border-b text-left">Eliminación del vello</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='eliminacionVello'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='eliminacionVelloTextArea'
                          />
                        </td>
                      </tr>    
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">7</td>
                        <td className="px-4 py-2 border-b text-left">Resultados de exámenes de laboratorio pre-quirúrgicos </td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='laboratorioPreQuirurgico'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='laboratorioPreQuirurgicoTextArea'
                          />
                        </td>
                      </tr>  
                      <tr  className="hover:bg-gray-100 bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">8</td>
                        <td className="px-4 py-2 border-b text-left">Electrocardiograma presente si está indicado (patologías cardiovasculares y/o mayores de 50 años).</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='electrocardiograma'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='electrocardiogramaTextArea'
                          />
                        </td>
                      </tr>   
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">9</td>
                        <td className="px-4 py-2 border-b text-left">Se toma medicamentos antihipertensivos o de patologías crónicas indicados</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='medicamentosAntihipertensivosOPatologias'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='medicamentosAntihipertensivosOPatologiasTextArea'
                          />
                        </td>
                      </tr>          
                      <tr  className="hover:bg-gray-100 bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">10</td>
                        <td className="px-4 py-2 border-b text-left">Suspensión de medicamentos ordenados por el anestesiólogo o cirujano ( medicamentos anticoagulantes, otros)</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='medicamentosAnestesiologo'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='medicamentosAnestesiologoTextArea'
                          />
                        </td>
                      </tr>          
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">11</td>
                        <td className="px-4 py-2 border-b text-left">Cuenta con reserva de  hemocomponentes, Consentimiento informado completamente diligenciado  y firmado</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='cuentaConReserva'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='cuentaConReservaTextArea'
                          />
                        </td>
                      </tr>     
                      <tr  className="hover:bg-gray-100 bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">12</td>
                        <td className="px-4 py-2 border-b text-left">Consentimiento de cirugía completo y correctamente diligenciado y firmado</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='consentimientoCirugia'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='consentimientoCirugiaTextArea'
                          />
                        </td>
                      </tr>      
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">13</td>
                        <td className="px-4 py-2 border-b text-left">Consentimiento de anestesia correctamente diligenciado y firmado</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='consentimientoAnestesia'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='consentimientoAnestesiaTextArea'
                          />
                        </td>
                      </tr>      
                      <tr  className="bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">14</td>
                        <td className="px-4 py-2 border-b text-left">Cuenta con material de osteosintesis o insumos especiales si es requerido para la cirugía</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='materialOsteosintesisOInsumos'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='materialOsteosintesisOInsumosTextArea'                            
                          />
                        </td>
                      </tr>         
                      <tr  className="">
                        <td className="px-4 py-2 border-b text-center">15</td>
                        <td className="px-4 py-2 border-b text-left">Reserva de UCI  si está indicado</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='reservaUCI'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='reservaUCITextArea'
                          />
                        </td>
                      </tr>         
                      <tr  className="bg-gray-100">
                        <td className="px-4 py-2 border-b text-center">16</td>
                        <td className="px-4 py-2 border-b text-left">Se evidencia paciente con uñas y  ojos sin maquillaje se retira  prótesis dental</td>
                        <td className="px-4 py-2 border-b">
                          <select                   
                            className="block w-full p-1 border rounded"
                            name='pacienteUnasMaquillaje'
                          >
                            <option value="2">N/A</option>
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </select>
                        </td>
                        <td className="px-4 py-2 border-b">
                          <textarea                   
                            className="block w-full p-1 border rounded"
                            name='pacienteUnasMaquillajeTextArea'
                          />
                        </td>
                      </tr>           
                  </tbody>
                </table>
              </div>
              <div className="w-3/3 m-2 text-left">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  OBSERVACIONES
                  </label>
                  <textarea
                    //onChange={handleOnchangeDescripcion}                
                    type="text"
                    name="observaciones"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
              </div>
              
              
            <div className="bg-[#05a29d] mt-3 text-center">
                <label className="form-label inline-block m-1 text-white font-medium text-center text-xl">                
                SIGNOS VITALES 
                </label>
            </div>
            <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Frecuencia Cardiaca
                  </label>
                  <input 
                    //max="3"     
                    type="number"                   
                    name="frecuenciaCardiaca"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    onInput={(e) => {
                      // Esto se asegura de que no se ingrese más de tres dígitos
                      if (e.target.value.length > 3) {
                        e.target.value = e.target.value.slice(0, 3);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Evita que el usuario ingrese letras o caracteres especiales
                      if (e.key.match(/[^0-9]/) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                        e.preventDefault();
                      }
                    }}
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  % Saturación de oxigeno
                  </label>
                  <input 
                    type="number"
                    name="saturacionOxigeno"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    onInput={(e) => {
                      // Esto se asegura de que no se ingrese más de tres dígitos
                      if (e.target.value.length > 5) {
                        e.target.value = e.target.value.slice(0, 5);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Evita que el usuario ingrese letras o caracteres especiales
                      if (e.key.match(/[^0-9]/) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                        e.preventDefault();
                      }
                    }}
                  />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Temperatura
                  </label>
                  <input
                    type="text"
                    name="temperatura"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal text-gray-900 bg-gray bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlInput1"
                    placeholder=""
                    onInput={(e) => {
                      // Capturamos el valor actual del input
                      let inputValue = e.target.value;

                      // Reemplazamos comas por puntos para estandarizar el formato
                      inputValue = inputValue.replace(',', '.');

                      // Expresión regular para permitir solo un número decimal con un solo punto o coma
                      const regex = /^\d*(\.|,)?\d{0,1}$/;

                      // Si no hay punto o coma, limitar a 2 caracteres
                      if (!inputValue.includes('.') && inputValue.length > 2) {
                        e.target.value = inputValue.slice(0, 2);
                      }
                      // Si hay punto o coma, limitar a 4 caracteres
                      else if (inputValue.length > 4) {
                        e.target.value = inputValue.slice(0, 4);
                      } else if (!regex.test(inputValue)) {
                        // Si el valor no coincide con el patrón, lo revertimos
                        e.target.value = e.target.value.slice(0, -1);
                      } else {
                        // Actualizamos el valor con el input ajustado
                        e.target.value = inputValue;
                      }
                    }}
                    onKeyDown={(e) => {
                      // Permitimos solo números, Backspace, Delete, y flechas para navegar
                      if (e.key.match(/[^0-9.,]/) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                        e.preventDefault();
                      }

                      // Evitamos que se ingrese más de un punto o coma
                      const inputValue = e.target.value;
                      if ((e.key === '.' || e.key === ',') && (inputValue.includes('.') || inputValue.includes(','))) {
                        e.preventDefault();
                      }
                    }}
                  />



                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Via Temperatura
                  </label>
                  <select 
                    type="text"
                    name="viaTemperatura"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    <option value="Axilar">Axilar</option>
                    <option value="Oral">Oral</option>
                    <option value="Otica">Otica</option>
                    <option value="Rectal">Rectal</option>
                    <option value="Infrarojo">Infrarojo</option>
                  </select>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Presión sistólica
                  </label>
                  <input 
                    //max="3"     
                    type="number"                   
                    name="presionSistolica"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    onInput={(e) => {
                      // Esto se asegura de que no se ingrese más de tres dígitos
                      if (e.target.value.length > 3) {
                        e.target.value = e.target.value.slice(0, 3);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Evita que el usuario ingrese letras o caracteres especiales
                      if (e.key.match(/[^0-9]/) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                        e.preventDefault();
                      }
                    }}
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Presión diastólica
                  </label>
                  <input 
                    type="number"
                    name="presionDiastolica"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    onInput={(e) => {
                      // Esto se asegura de que no se ingrese más de tres dígitos
                      if (e.target.value.length > 3) {
                        e.target.value = e.target.value.slice(0, 3);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Evita que el usuario ingrese letras o caracteres especiales
                      if (e.key.match(/[^0-9]/) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                        e.preventDefault();
                      }
                    }}
                  />
                  </div>
                </div>
                
                
                <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Peso (Kg)
                  </label>
                  <input 
                    //max="3"     
                    type="number"                   
                    name="peso"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    onInput={(e) => {
                      // Esto se asegura de que no se ingrese más de tres dígitos
                      if (e.target.value.length > 5) {
                        e.target.value = e.target.value.slice(0, 5);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Evita que el usuario ingrese letras o caracteres especiales
                      if (e.key.match(/[^0-9]/) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                        e.preventDefault();
                      }
                    }}
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Talla (cm)
                  </label>
                  <input 
                    type="number"
                    name="talla"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    onInput={(e) => {
                      // Esto se asegura de que no se ingrese más de tres dígitos
                      if (e.target.value.length > 5) {
                        e.target.value = e.target.value.slice(0, 5);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Evita que el usuario ingrese letras o caracteres especiales
                      if (e.key.match(/[^0-9]/) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                        e.preventDefault();
                      }
                    }}
                  />
                  </div>
                </div>
                
                
                <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div>
                
            </form>
            
          </div>
          
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }   
      {modalOnValidacionesSignosVitales? <ModalValidacionSignosVitalesListaChequeo setmodalOnValidacionesSignosVitales={setmodalOnValidacionesSignosVitales} validacionesSignosVitales={validacionesSignosVitales}/>:null}   
      {modalOnConfirmarListaChequeo? <ConfimarListaChequeo setmodalOnConfirmarListaChequeo={setmodalOnConfirmarListaChequeo} dataListaChequeo={dataListaChequeo} user={user} passChildCambioDeEstado={passChildCambioDeEstado} setmodalOnListaChequeo={setmodalOnListaChequeo} setmodalOnCambioEstadoIngresoSala={setmodalOnCambioEstadoIngresoSala} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>:null}
      {modalOnFaltoDiligenciarCampos? <ModalFaltoCamposPorDiligenciarListaChequeo setmodalOnFaltoDiligenciarCampos={setmodalOnFaltoDiligenciarCampos} dataListaChequeo={dataListaChequeo} validarAlergiasSiEsSi={validarAlergiasSiEsSi}/>:null}
      
      
    </div>
  )
}

export default ListaDeChequeoPreparacionPreoperatoriaPrincipal